"use client";

import { Card, Stack, Text, Group } from "@forestsync/ui";
import Link from "next/link";
import { TOKEN_STATUS_TW_CLASS } from "@forestsync/lib/type-utils";
import { TOKEN_STATUS } from "@forestsync/db";
import { useTranslations } from "next-intl";
import type { TokenListItem } from "@/types/glassroom";

interface TokenCardProps {
  token: TokenListItem;
}

export function TokenCard({ token }: TokenCardProps) {
  const t = useTranslations();
  const twClass = TOKEN_STATUS_TW_CLASS[token.status];

  return (
    <Link href={`/passport/${token.serialNumber}`} className="block h-full">
      <Card
        className={`h-full cursor-pointer ${twClass} transition-shadow duration-200 hover:shadow-lg hover:ring-2 hover:translate-y-[-2px]`}
      >
        <Stack gap="sm">
          <Text size="sm" fw={700} className={`font-mono break-all`}>
            {token.serialNumber}
          </Text>
          <Group gap="xs" align="center">
            <Text size="sm" className="text-gray-500 dark:text-gray-400">
              {t("common.owner")}:
            </Text>
            <Text size="sm" className="wrap-break-word">
              {token.status === TOKEN_STATUS.INSURANCE_POOL
                ? t("common.insurancePool")
                : token.currentOwnerName}
            </Text>
          </Group>
        </Stack>
      </Card>
    </Link>
  );
}
